import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/search/search.module').then((m) => m.SearchModule)
  },
  {
    path: 'trace',
    loadChildren: () =>
      import('./features/traceability/traceability.module').then(
        (m) => m.TraceabilityModule
      )
  },
  { path: '**', redirectTo: '' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
